import { Routes } from '@navigation';
import { mc, StyleProps } from '@styles';
import React, { FC } from 'react';

import LogoImg from './assets/logo.inline.svg';

interface Props extends StyleProps {
  onClick?: () => void;
}

export const NavigationBarLogo: FC<Props> = ({ className, onClick }) => {
  return (
    <a className={mc('flex items-center justify-center hover:opacity-70', className)} href={Routes.home.url} onClick={onClick}>
      <LogoImg />
    </a>
  );
};

export type NavigationBarLogoProps = Props;
export default NavigationBarLogo;
